import React from 'react'
import _ from 'lodash'
import Menu from './Menu.jsx'
import Player from './Player.jsx'
import Loading from './Loading.jsx'

export default class App extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      playerReady: false
    }
    this.showSidebar = this.showSidebar.bind(this)
    this.showMenu = this.showMenu.bind(this)
    this.playerReady = this.playerReady.bind(this)
  }
  showSidebar(player) {
    // If we have no videos, we don't need the archive list
    if (player.videos.length === 0)
      return false

    // Don't show if player is live only
    if (player.qs.liveOnly && !App.config.showArchives)
      return false

    // Archives are disabled in the player
    if (!App.config.showArchives)
      return false
    // Disable for VideoPlayer
    if (player.qs.video)
      return false
    return true
  }
  showMenu(player) {
    // Don't show if player is live only
    if (player.qs.liveOnly && !App.config.showSubscribe && !App.config.showSchedule)
      return false
      // Disable for single VideoPlayer
    if (player.qs.video)
      return false
    return true
  }
  getMeta(ssId, cb) {
    $.get('/venue/'+ssId, function(response) {
      var meta = response.data.meta
      meta = _.mapValues(meta, function(n) {
        if(n === '1' || n === '0') return parseInt(n)
        return n
      })
      cb(meta)
    })
  }
  playerReady(player){
    player.getBroadcaster(player.qs.ssId, () => {
      this.getMeta(player.qs.ssId, (meta) => {
        this.setState(_.extend({
          playerReady: true,
          player: player
        }, meta))
      })
    })
  }
  render(){
    if(this.state.playerReady){
      return(<PlayerReady player={this.state.player} showSchedule={this.state.showSchedule} showSubscribe={this.state.showSubscribe} config={this.props.player} isReady={this.playerReady} />)
    }else {
      return (<PlayerNotReady config={this.props.player} isReady={this.playerReady} />)
    }
  }
}

const PlayerNotReady = (props) => {
  return (
    <div>
      <div id="ss-video-secion" className="col-md-8 col-md-offset-2">
        <Player config={props.config} isReady={props.isReady} />
        <Loading/>
      </div>
    </div>
  )
}

const PlayerReady = (props) => {
  return (
    <div>
      <div id="ss-video-secion" className="col-md-8 col-md-offset-2">
        <Player config={props.config} isReady={props.isReady} />
        <Menu player={props.player} showSchedule={props.showSchedule} showSubscribe={props.showSubscribe}/>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Video.jsx